import ButtonLink from '@/common/components/ButtonLink'
import { cn } from '@/common/utils/cn'
import { RewardLedgerEntryData } from '@/features/tmaisUsers/types/rewardLedgerEntries.type'
import { CircleIcon } from 'lucide-react'
import { CardInfoCell } from './CardInfoCell'
import { CardWrapper } from './CardWrapper'

interface RedeemedItemCardProps {
  entry: RewardLedgerEntryData
}

export const RedeemedItemCard = ({ entry }: RedeemedItemCardProps) => {
  const isNegative = parseFloat(entry.quantity_earned) < 0

  const getItemName = (entry: RewardLedgerEntryData): string => {
    if (entry.from && 'product' in entry.from) {
      return entry.from.product.display_name
    }

    return entry.reward?.display_name || '--'
  }

  return (
    <CardWrapper entry={entry}>
      <div className="grid grid-cols-2 gap-2">
        <CardInfoCell label="Item resgatado">
          <ButtonLink
            linkTo={`/tmais-reward-items/${entry.reward?.id}`}
            operationKlassToCheckPermission="Admin::Tmais::Products::Show"
            hoverBackgroundSize="small"
          >
            <CircleIcon className="size-4 fill-slate-200 shrink-0" />

            <span className="text-sm truncate">{getItemName(entry)}</span>
          </ButtonLink>
        </CardInfoCell>

        <CardInfoCell label="Produtos">
          <img src="/TCoinProduct.svg" alt="TCoinProduct" className="size-4" />

          <span
            className={cn('text-sm', {
              'text-danger-soft': isNegative,
            })}
          >
            {Number(entry.quantity_earned ?? 0)}
          </span>
        </CardInfoCell>
      </div>
    </CardWrapper>
  )
}
